import { useCallback, useEffect, useState } from 'react';
import { StoreInfo } from 'services/api/store';
import { uniqBy } from 'lodash-es';
import { message } from 'antd';
import { useTranslate } from '@tolgee/react';

export const MAX_SELECTED_LENGTH = 100;

const useStoreSelector = (initSelected?: StoreInfo[], mutiple?: boolean) => {
  const [selected, setSelected] = useState<StoreInfo[]>(initSelected || []);
  const { t } = useTranslate();
  const onChange = useCallback(
    (item: StoreInfo[], checked: boolean) => {
      if (mutiple) {
        // 多选
        if (checked) {
          let next = uniqBy([...selected, ...item], 'storeId');
          if (next.length > MAX_SELECTED_LENGTH) {
            message.warn(t('storeSelector.最多可选中{x}家店铺', { num: MAX_SELECTED_LENGTH }));
            next = next.slice(0, MAX_SELECTED_LENGTH);
          }
          setSelected(next);
        } else {
          setSelected((pre) => pre.filter((x) => !item.find((y) => y.storeId === x.storeId)));
        }
      } else {
        // 单选
        setSelected(checked ? [...item] : []);
      }
    },
    [mutiple, selected, t],
  );
  useEffect(() => {
    setSelected(initSelected || []);
  }, [initSelected]);
  const isSelected = useCallback(
    (id: string) => {
      return !!selected.find((x) => x.storeId === id);
    },
    [selected],
  );
  return {
    selected,
    onChange,
    isSelected,
  };
};

export default useStoreSelector;
